import { StylePropertyDefinition } from '../../types/common';

// The agent's chrome is platform UI over someone else's app and takes nothing
// from the app's theme, so there is nothing here to theme.
export const styleProperties: Array<StylePropertyDefinition> = [];
export const styleDefaults = new Map<string, string>();
